import { ActionTypes } from '../constants'
import { logout } from '@app/actions/session'

export const apiError = (error) => {
  return {
    type: ActionTypes.API_ERROR,
    error: error
  }
}

export const accessDenied = (error) => {
  return {
    type: ActionTypes.ACCESS_DENIED,
    error: error,
    path: window.location.pathname
  }
}

export const networkError = (error) => {
  return {
    type: ActionTypes.NETWORK_ERROR,
    error: error
  }
}

export const notAuthorized = (error) => logout()

export const clearApiState = () => {
  return { type: ActionTypes.CLEAR_API_ERRORS }
}
